var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReproduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000004520149728376649860000017443984042016433340_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8.1,
    y: 8.1,
    width: 86.7,
    height: 86.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011751918210377463140000000882174250883465095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011751918210377463140000000882174250883465095_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8,44L77,24.5c-2.3-3.8-6.5-6.2-10.9-6.2h-1.9v-2.5c0-4.2-3.4-7.6-7.6-7.6H46.4c-4.2,0-7.6,3.4-7.6,7.6v2.5h-1.9 c-4.4,0-8.6,2.4-10.9,6.2L14.2,44c-3.5,0.7-6.1,3.8-6.1,7.5v10.2c0,3.7,2.6,6.8,6.1,7.5L26,88.7c2.3,3.8,6.5,6.2,10.9,6.2h29.2 c4.4,0,8.6-2.4,10.9-6.2l11.8-19.6c3.5-0.7,6.1-3.8,6.1-7.5V51.5C94.9,47.8,92.3,44.7,88.8,44z M43.9,15.8c0-1.4,1.1-2.5,2.5-2.5 h10.2c1.4,0,2.5,1.1,2.5,2.5v2.5H43.9V15.8z M89.8,61.7c0,1.4-1.1,2.5-2.5,2.5c-0.9,0-1.7,0.5-2.2,1.2L72.6,86.1 c-1.4,2.3-3.9,3.7-6.5,3.7H36.9c-2.7,0-5.2-1.4-6.5-3.7L17.9,65.4c-0.5-0.8-1.3-1.2-2.2-1.2c-1.4,0-2.5-1.1-2.5-2.5v-2.5h13 l11.5,19.1c0.5,0.8,1.3,1.2,2.2,1.2h23.4c0.9,0,1.7-0.5,2.2-1.2l11.5-19.1h13V61.7z M38.8,59.1v11.2l-6.7-11.2H38.8z M32.1,54 l6.7-11.2V54H32.1z M49,59.1v15.2h-5.1V59.1H49z M43.9,54V38.8H49V54H43.9z M59.1,59.1v15.2H54V59.1H59.1z M54,54V38.8h5.1V54H54z  M70.9,59.1l-6.7,11.2V59.1H70.9z M64.2,54V42.9L70.9,54H64.2z M89.8,54h-13L65.4,34.9c-0.5-0.8-1.3-1.2-2.2-1.2H39.8 c-0.9,0-1.7,0.5-2.2,1.2L26.2,54h-13v-2.5c0-1.4,1.1-2.5,2.5-2.5c0.9,0,1.7-0.5,2.2-1.2l12.5-20.7c1.4-2.3,3.9-3.7,6.5-3.7 c0.8,0,28.4,0,29.2,0c2.7,0,5.2,1.4,6.5,3.7l12.5,20.6c0.5,0.8,1.3,1.2,2.2,1.2c1.4,0,2.5,1.1,2.5,2.5V54z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReproduction);
export default __webpack_public_path__ + "static/media/reproduction.50387ac1f986bcd19f138be3eb07a7c4.svg";
export { ForwardRef as ReactComponent };